export {default as queue} from "./src/queue";



//////////////////
// WEBPACK FOOTER
// ./~/d3-queue/index.js
// module id = 375
// module chunks = 14